import { module } from 'modujs';
import modularLoad from 'modularload';
import { getGTMContext } from '../utils/gtm';

class superLoad extends modularLoad {
    refresh(href, transition) {
        this.reset()
        this.transition = transition
        this.isUrl = void 0

        this.setOptions((href || window.location.href), false)
    }
}

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.load = new superLoad({
            enterDelay: 0,
            transitions: {
                light: {
                    enterDelay: 1000
                }
            }
        });
        this.initialContainer = document.querySelector(`[${this.load.container}]`)

        this.load.on('loaded', (transition, oldContainer, newContainer) => {
            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');
            this.call('resetScrollInstance', null, 'Scroll')

            //send transition page view
            this.sendPageView(newContainer);
        });

        this.load.on('loading', (transition, oldContainer) => {
            this.call('close', null, 'Menu')

            if(transition == 'light') {
                this.call('scrollTo', [oldContainer, {offset: -300}], 'Scroll')
            }
        });

        //send 1st hit pageview
        this.sendPageView(this.initialContainer);
    }

    goTo(obj) {
        this.load.goTo(obj.url, obj.transition);
    }

    refresh(options) {
        let { url, transition } = options
        this.load.refresh(url, transition)
    }

    sendPageView(container) {
        const context = getGTMContext(container);

        if(window.dataLayer && context) {
            window.dataLayer.push({
                "event": "page_view",
                ...context
            })

            if(window.isDebug) {
                console.log(window.dataLayer);
            }
        }
    }
}
